/** @file Texture page table shared by geometry, overlay and every renderer: atlas pages plus two built-ins. */
import type { TexturePageData } from '@pose2d/core/types';

export interface TexturePages {
  /** Atlas (or identity) pages first, then the built-in `white` (1x1) and `font` (bitmap glyph atlas, nearest) pages. */
  pages: TexturePageData[];
  /** Index of the built-in 1x1 white page. */
  white: number;
  /** Index of the built-in bitmap-font page. */
  font: number;
}

export const BUILTIN_PAGES = { white: 'white', font: 'font' } as const;
